/**
 * @generated SignedSource<<e0facdcb73d74282dc7c0ea01ba61d92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
export type TeamAdminIdentifiersScreenMutation$variables = {
  newColor: string;
  newIcon: TeamIcon;
  newName: string;
  teamId: string;
};
export type TeamAdminIdentifiersScreenMutation$data = {
  readonly team: {
    readonly updateColor: {
      readonly color: string | null;
      readonly id: string;
    };
    readonly updateIcon: {
      readonly icon: TeamIcon | null;
      readonly id: string;
    };
    readonly updateName: {
      readonly id: string;
      readonly name: string;
    };
  };
};
export type TeamAdminIdentifiersScreenMutation = {
  response: TeamAdminIdentifiersScreenMutation$data;
  variables: TeamAdminIdentifiersScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newColor"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newIcon"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newName"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "teamId"
      }
    ],
    "concreteType": "TeamMutation",
    "kind": "LinkedField",
    "name": "team",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "newName",
            "variableName": "newName"
          }
        ],
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "updateName",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "newIcon",
            "variableName": "newIcon"
          }
        ],
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "updateIcon",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "icon",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "newColor",
            "variableName": "newColor"
          }
        ],
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "updateColor",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamAdminIdentifiersScreenMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamAdminIdentifiersScreenMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "0a6e569fa1c2ee5b93fb3986953d787f",
    "id": null,
    "metadata": {},
    "name": "TeamAdminIdentifiersScreenMutation",
    "operationKind": "mutation",
    "text": "mutation TeamAdminIdentifiersScreenMutation(\n  $teamId: ID!\n  $newName: String!\n  $newIcon: TeamIcon!\n  $newColor: String!\n) {\n  team(id: $teamId) {\n    updateName(newName: $newName) {\n      id\n      name\n    }\n    updateIcon(newIcon: $newIcon) {\n      id\n      icon\n    }\n    updateColor(newColor: $newColor) {\n      id\n      color\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e2c74048d0a558572ba0c2ce25d4caf6";

export default node;
